export enum TenancyStatus {
  Current = 0,
  NoticedServiced = 1,
  TenantLeaving = 2,
  TenantRenewing = 3,
  Cancelled = 7,
  PreTenancy = 8,
  Expired = 9,
}
